import React from 'react'
import { Grid, Typography } from '@mui/material'
import { Replay } from '@mui/icons-material'
import { connect } from 'react-redux'
import * as common from '../../../appRedux/actions/common'
import * as info from '../../../appRedux/actions/info'
import IntlMessages from '../../../util/IntlMessages'
import * as constants from '../../../constants'
import useStyles from './bottom_content.style'

function TopContent(props) {
    const classes = useStyles()
    let requestDetails = props.field.requestOnline

    return (
        <React.Fragment>
            <Grid style={{ marginLeft: 40 }}>
                <Grid container className={classes.gridPaymentType}>
                    <Grid item xs={10} md={10}>
                        <Typography variant="body2">
                            {requestDetails.iPaymentType === constants.PAYMENT_TYPE_CREDIT
                                ? <IntlMessages id="theRequestAmountWillBeDeductedFromUserWallet" />
                                : <IntlMessages id="theTypeOfPaymentIsCash" />}
                        </Typography>
                    </Grid>
                    <Grid
                        item xs={2} md={2}
                        className={classes.gridReplayIcon}
                        onClick={() => props.requestDetailsFunc()}>
                        <Replay className={classes.replayIcon} />
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        field: state.field
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        redirectAction: (router) => dispatch(common.redirectAction(router)),
        getSupportNumberAction: () => dispatch(info.getSupportNumberAction())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopContent)